module.exports = __webpack_public_path__ + "static/media/light-rain-weather_200_transparent.43ac538b.gif";